"use client";

import { useState } from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";
import type { BlogCategory } from "@/types/blog";
import CustomButton from "../ui/custom-button";

interface BlogFilterBarProps {
  categories: BlogCategory[];
  activeCategory: string;
  searchQuery: string;
  onCategoryChange: (category: string) => void;
  onSearchChange: (query: string) => void;
  className?: string;
}

export function BlogFilterBar({
  categories,
  activeCategory,
  searchQuery,
  onCategoryChange,
  onSearchChange,
  className,
}: BlogFilterBarProps) {
  const [_isSearchFocused, setIsSearchFocused] = useState(false);

  return (
    <div
      className={cn(
        "flex flex-col font-outfit lg:flex-row gap-4 items-start sm:items-center justify-between mb-8",
        className
      )}
    >
      {/* Search */}
      <div className="relative w-full sm:w-auto">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <input
          type="text" aria-label="Enter Search Term"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          onFocus={() => setIsSearchFocused(true)}
          onBlur={() => setIsSearchFocused(false)}
          className={cn(
            "pl-10 rounded-[8px] border-transparent focus:ring-transparent focus:border-transparent     focus:outline-none    !py-3 bg-site-card text-white placeholder:text-white/50 w-full sm:w-64"
          )}
        />
      </div>

      {/* Category Filters */}
      <div className="flex flex-wrap gap-2">
        {categories.map((category) => (
          <CustomButton
            key={category.id}
            variant={activeCategory === category.slug ? "default" : "ghost"}
            size="sm"
            onClick={() => onCategoryChange(category.slug)}
            className={cn(
              "",
              activeCategory === category.slug
                ? "bg-yellow-500 text-black hover:bg-yellow-600"
                : "border-zinc-700 text-white hover:bg-zinc-800 hover:text-white"
            )}
          >
            {category.name}
          </CustomButton>
        ))}
      </div>
    </div>
  );
}
